import { BgModal, Container } from "./style";

import ImgCellphone from "../../assets/img/cellphones.png";
import GooglePlay from "../../assets/img/google-play.png";
import PlayStore from "../../assets/img/play-store.png";
import QrCode from "../../assets/img/qr-code.png";

import { Button } from "../Button";

import { X } from "phosphor-react";
import { useTranslation } from 'react-i18next'

export const Modal = ({ modalOpen, setModalOpen }) => {
  const { t } = useTranslation();
  const handleApp = () => {
    window.open(
      "https://smartfitapp.page.link/4cqW",
      "_blank"
    );
  };

  return (
    <>
      <BgModal>
        <Container>
          <div className="modal-top">
            <div className="modal-top-bg">
              <figure>
                <img src={ImgCellphone} alt="telefones" />
              </figure>
            </div>
            <div className="modal-top-controller">
              <i>
                <X onClick={() => setModalOpen(!modalOpen)} />
              </i>
            </div>
          </div>
          <div className="modal-bottom">
            <h3>{t('confirmationPage.modal.title')}</h3>
            <div className="modal-bottom-mobile">
              <p>
                {t('confirmationPage.modal.subtitle')}
              </p>
              <p>
                {t('confirmationPage.modal.subtitleAppBold')}
              </p>
              <Button label={t('confirmationPage.modal.appAction')} evt={handleApp} />
            </div>
            <div className="modal-bottom-apps">
              <p>
                {t('confirmationPage.modal.subtitle')}
                {' '}
                <span>{t('confirmationPage.modal.subtitleBold')}</span>
              </p>
              <div className="modal-bottom-apps-container">
                <div className="modal-bottom-apps-qr">
                  <figure>
                    <img src={QrCode} alt="qr code" />
                  </figure>
                </div>
                <div className="modal-bottom-apps-lojas">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.eokoe.smartfitcoach"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <figure>
                      <img src={GooglePlay} alt="google play store" />
                    </figure>
                  </a>
                  <a
                    href="https://apps.apple.com/br/app/smart-fit-app/id1308265270"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <figure>
                      <img src={PlayStore} alt="App Store" />
                    </figure>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </BgModal>
    </>
  );
};
